<br />
<br />
<br />
<br />

<div class="row mx-4" *ngIf="articles.length">
  <div
    class="col-12 col-sm-6 col-md-4 col-lg-3 p-3"
    *ngFor="let article of articles"
  >
    <div class="card" routerLink="{{ '/articleDetails/' + article.articleId }}">
      <img
        [src]="getFullImageUrl(article.imageUrl)"
        class="card-img-top"
        alt="{{ article.title }}"
      />

      <h4 class="card-title mx-2 mt-2">{{ article.title }}</h4>
      <p class="card-text mx-2 mb-2">
        {{ article.description }}
      </p>
    </div>
  </div>
</div>

<h3 *ngIf="articles.length === 0" class="mt-5 text-center">
  {{ "No Articles Yet" | translate }}
</h3>
